import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";

import LogoIcon from "../../assets/images/logo-icon.png";
import { authConstants, VERIFICATION_TOKEN } from "../../constants";
import BaseModal from "../../shared/components/modals/BaseModal";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import { authActions } from "../../redux/actions";

const EmailVerification = ({
  verifyUser,
  verifyEmail,
  spinnerActions,
  setIsNavigateToDefault,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const encryptedParams = searchParams.get(VERIFICATION_TOKEN);

  const [openModal, setOpenModal] = useState(true);

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  const closeModal = () => {
    setOpenModal(false);
    navigateToLogin();
  };

  const navigateToLogin = () => {
    navigate("/", {
      replace: true,
    });
    setIsNavigateToDefault(true);
  };

  // Use effect that creates object from values from params and verifies it
  useEffect(() => {
    if (encryptedParams) {
      verifyEmail(encryptedParams);
    } else {
      navigateToLogin();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {spinner(authConstants.VERIFY_EMAIL) > -1 ? (
        <MainSpinner />
      ) : (
        <BaseModal
          size="xs"
          showClose={true}
          show={openModal}
          fullScreen={false}
          onClose={closeModal}
          backDropClass="login-modal-backdrop"
          dialogClassName="login-modal-dialog"
        >
          <div className="forgot-form mt-0">
            <div className="d-flex justify-content-center mb-5">
              <img src={LogoIcon} alt="Bayview Shores" height={49} />
              <p className="login-brand-logo">Bayview Shores</p>
            </div>
            {verifyUser?.userId ? (
              <>
                <div className="forgot-desc reset-desc text-center">
                  Your email has been successfully verified!
                </div>
              </>
            ) : verifyUser?.emailAlreadyVerified ? (
              <>
                <div className="forgot-desc reset-desc text-center">
                  Your email is already verified!
                </div>
              </>
            ) : (
              <>
                <p className="pt-5 text-center">
                  Your Email Verification Link has been expired.
                  <br />
                  Please contact with support team.
                </p>
              </>
            )}
            <RoundedButton
              cotainerClass="w-100 d-flex justify-content-center"
              className="px-5 py-2"
              onClick={navigateToLogin}
            >
              Login
            </RoundedButton>
          </div>
        </BaseModal>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  verifyUser: state.authReducer.verifyUser,
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  verifyEmail: (body) => dispatch(authActions.verifyEmail(body)),
  resetPassword: (data, onSuccess) =>
    dispatch(authActions.resetPassword(data, onSuccess)),
  setIsNavigateToDefault: (flag) =>
    dispatch(authActions.setIsNavigateToDefault(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerification);
